// This file tells Inertia how to resolve page components
// It auto-imports all Vue components from the pages directory
import type { DefineComponent } from 'vue';

const pages = import.meta.glob<DefineComponent>('./pages/**/*.vue');

const resolvePage = (name: string) => {
    // Convert dot notation to path (e.g., 'admin.UsersIndex' -> './pages/admin/UsersIndex.vue')
    const pagePath = `./pages/${name.replace(/\./g, '/')}.vue`;

    // Find and return the page component
    const page = pages[pagePath];

    if (!page) {
        throw new Error(`Page not found: ${name}`);
    }

    return page();
};

export default resolvePage;
